<script setup lang="ts">
const { showAvatars = false, action = "Find", nSailors = 554 } = defineProps<{
  showAvatars: boolean, action: string, nSailors: number
}>()
</script>

<template>
  <div class="d-flex flex-wrap flex-row ga-5 justify-center text-center">
    <div v-if="showAvatars">
      <v-avatar
          color="teal"
      >JD</v-avatar>
      <v-avatar
          class="ml-n2"
          color="lime"
      >MG</v-avatar>
      <v-avatar
          class="ml-n2"
          color="orange"
      >PD</v-avatar>
      <v-avatar
          class="ml-n2"
          color="blue-grey"
      >MH</v-avatar>
      <v-avatar
          class="ml-n2"
      >
        <v-img src="https://storage.googleapis.com/sailingmetrics-prod-media/avatars/user-515.jpg" alt="" />
      </v-avatar>
    </div>
    <div class="d-flex flex-column text-center">
      <div>
        <v-no-ssr>
        <v-rating
            :model-value="5"
            active-color="orange-lighten-1"
            color="orange-lighten-1"
            density="compact"
            readonly
        ></v-rating>
        </v-no-ssr>
      </div>
      <span class="font-weight-light">
                  {{ action }} {{ nSailors }} sailors on SailingMetrics.
                </span>
    </div>
  </div>

</template>

